
import { createApp } from 'vue/dist/vue.esm-bundler'
import SliderOne from './components/SliderOne.vue';
import ProductBest from './components/ProductBest.vue';
import IntroductionBrand from './components/IntroductionBrand.vue';
import BrandShow from './components/BrandShow.vue';
import ShowDropdon from './components/ShowDropdon.vue';
import SliderGallery from './components/SliderGallery.vue';
//import ShowslidGallery from './components/ShowslidGallery.vue';
import ScrollUp from './components/ScrollUp.vue';
import DesProduct from './components/DesProduct.vue';
import MenuMoblie from './components/MenuMoblie.vue';

 const app =  createApp({

    components: {
        SliderOne,
        ProductBest,
        IntroductionBrand,
        BrandShow,
        ShowDropdon,
        SliderGallery,
        ScrollUp,
        DesProduct,
        MenuMoblie,
    }

});
app.mount('#app');
///const app = createApp({});

//app.component('slider-One', SliderOne)


//app.mount('#app');



